/**
 * 서울 지도 — 단일 path SVG.
 *
 * 디자인 의도(피그마 주석): "서울특별시는 전 지역 서비스 가능하기 때문에 별도 터치포인트 X"
 *  - 시군구별 분리 X
 *  - 클릭 인터랙션 X
 *  - 색은 SVG 안에 박혀있음 (#FF8A5E)
 *
 * 다른 시도(경기 등)와 다르게 합성 SVG가 아닌 단일 일러스트 형태.
 * 라벨 "서울특별시"는 SVG 위 중앙에 absolute로 박힘.
 */

import seoulSvgUrl from '@/assets/maps/seoul.svg'

import { MapBox, MapImage, SidoLabel } from './SeoulMap.styles'

const SEOUL_SVG_WIDTH = 210
const SEOUL_SVG_HEIGHT = 180

export default function SeoulMap() {
  return (
    <MapBox>
      <MapImage
        src={seoulSvgUrl}
        alt='서울특별시 지도'
        width={SEOUL_SVG_WIDTH}
        height={SEOUL_SVG_HEIGHT}
      />
      <SidoLabel>서울특별시</SidoLabel>
    </MapBox>
  )
}
